import { Button } from "@fluidattacks/design";
import React from "react";
import { useTheme } from "styled-components";

import { states } from "./icons";

import { useIconAnimation } from "hooks/use-icon-animations";
import { useChatStore } from "pages/dashboard/mcp-chat/use-chat-store";

const svgStates: string[] = [states.state1, states.state2, states.state3];

const AIButton: React.FC = (): JSX.Element => {
  const theme = useTheme();
  const { isOpen, toggleIsOpen } = useChatStore();
  const {
    currentState: currentIndex,
    activate: handleMouseEnter,
    stop: handleMouseLeave,
    isActive: isHovered,
  } = useIconAnimation(svgStates.length);
  const icon = isHovered ? undefined : "sparkles";

  return (
    <Button
      alignItems={"center"}
      aria-label={isOpen ? "Close chat" : "Open chat"}
      bgGradient={"linear-gradient(180deg, #F32637 0%, #BF0B1A 100%)"}
      color={theme.palette.black}
      display={"flex"}
      icon={isOpen ? "sparkles" : icon}
      iconColor={isOpen ? theme.palette.primary[500] : theme.palette.gray[700]}
      iconType={"fa-solid"}
      onClick={toggleIsOpen}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        backgroundColor:
          isOpen || isHovered ? theme.palette.primary[25] : "transparent",
        color: isOpen ? theme.palette.primary[500] : theme.palette.gray[700],
        margin: "0px",
      }}
      variant={"ghost"}
    >
      {isHovered && !isOpen ? (
        <span style={{ verticalAlign: "middle" }}>
          <svg
            dangerouslySetInnerHTML={{ __html: svgStates[currentIndex] }}
            fill={"none"}
            height={"16"}
            viewBox={"0 0 65 65"}
            width={"16"}
            xmlns={"http://www.w3.org/2000/svg"}
          />
        </span>
      ) : undefined}
      {"AI Agent"}
    </Button>
  );
};

export { AIButton };
